import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { style: {"margin":"-20px 0 -22px 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mb-4" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Social Search"),
        _createElementVNode("span", null, "Total Traffic In This Week")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "radialBar",
              height: "230",
              options: _ctx.socialSearch,
              series: _ctx.search
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}